// extracted by mini-css-extract-plugin
export var cell = "_5l-4";
export var headerCell = "_5l-2";
export var rowHeader = "_5l-3";
export var table = "_5l-1";
export var tableContainer = "_5l-0";